import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material';

export const ColdPlateIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Cold plate body */}
      <rect x="4" y="4" width="16" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />

      {/* Serpentine coolant channel */}
      <path
        d="M6 6h12v2H6v2h12v2H6v2h12v2H6v2h12"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
      />

      {/* Inlet & outlet */}
      <circle cx="3" cy="6" r="1" fill="currentColor" />
      <circle cx="21" cy="18" r="1" fill="currentColor" />

      {/* Mounting holes */}
      <circle cx="5" cy="5" r="0.5" fill="currentColor" />
      <circle cx="19" cy="5" r="0.5" fill="currentColor" />
      <circle cx="5" cy="19" r="0.5" fill="currentColor" />
      <circle cx="19" cy="19" r="0.5" fill="currentColor" />
    </SvgIcon>
  );
}; 